<div class="dialog-error_inner">
  <ng-content></ng-content>
</div>
